












import mixins from 'vue-typed-mixins';

import InterniDruhDuvodInput from '../../components/microcomponents/InterniDruhDuvodInput.vue';
import InterniDruhSelect from '../../components/microcomponents/InterniDruhSelect.vue';
import InterniSkupinaProfilSelect from '../../components/microcomponents/InterniSkupinaProfilSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';
import { EditMixin } from '../../mixins/editMixin';

export default mixins(EditMixin).extend({
	name: 'InterniKarta',
	components: {
		InterniSkupinaProfilSelect,
		InterniDruhSelect,
		InterniDruhDuvodInput,
		SlevaInputNumber,
	},
});
